import React from 'react'
import { NavbarItem } from 'bloomer'

export default ({children, style, component}) => {
  const Item = component ? component : NavbarItem

  return (
    <Item style={{textTransform: 'uppercase', fontWeight: 'bold', ...style}}>
      {children}
    </Item>
  )
}



// WEBPACK FOOTER //
// ./src/components/HeaderTitle.js